// Kept independent of the script UI so shared persistence can compare revisions.
export const SCRIPT_TEXT_FIELDS = [
  'title', 'hook', 'scriptAngle', 'visualConcept', 'inspoLinks', 'scriptBody',
  'cta', 'caption', 'hashtags', 'valueProp', 'brandNameProvided',
] as const;

/** Legacy rows start at zero. Only a committed text change advances this value. */
export function scriptTextVersion(row: unknown): number {
  const value = (row as Record<string, unknown> | null)?.textVersion;
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : 0;
}

export function sameScriptText(a: unknown, b: unknown): boolean {
  const left = a as Record<string, unknown> | null;
  const right = b as Record<string, unknown> | null;
  return SCRIPT_TEXT_FIELDS.every((field) => JSON.stringify(left?.[field] ?? (field === 'inspoLinks' ? [] : ''))
    === JSON.stringify(right?.[field] ?? (field === 'inspoLinks' ? [] : '')));
}
